(ns frontend.test.inputs
  (:require
   [common.localization :as loc]
   [common.currencies :as currencies]
   [common.schema.constraints :as constraints]
   [frontend.routing :as routing]
   [frontend.logging :as logging]
   [frontend.components.field-editor :as field-editor]
   [potpuri.core :refer [dissoc-in]]
   [frontend.components.inputs.all]
   [frontend.intelligence.icon :as intelligence-icon]
   [frontend.components.inputs.footprint :refer [editor]]
   [reagent.core :as r]
   [frontend.db :as db]
   [common.intelligence.common :as ic]
   [clojure.string :as string]
   [common.schema.field :as field]
   [frontend.state.current-session :as session]))

(def test-state (r/cursor db/app-state [:test :editor]))
(def test-entity (r/cursor db/app-state [:test :test-data]))
(def test-entity-read-only (r/cursor db/app-state [:test :test-data-read-only]))
(def test-entities (r/cursor db/app-state [:test :test-oppos]))
(def test-table-atom (r/cursor db/app-state [:test :table]))
(def test-table-temp-atom (r/cursor db/app-state [:test :table-temp]))

(def test-schema
  {:test/text             {:field/default-ord        0
                           :field/data-type          :data.type/text
                           :field/default-visibility {:editor :editor.type/text-simple}
                           :field/constraints        {:constraint/string-min-length 1
                                                      :constraint/string-max-length 10}
                           :field/translations       {:en "Text [1-10]"}}

   :test/checkbox         {:field/default-ord        1
                           :field/data-type          :data.type/boolean
                           :field/default-visibility {:editor :editor.type/checkbox}
                           :field/translations       {:en "Checkbox"}}
   :test/date             {:field/default-ord        2
                           :field/data-type          :data.type/date
                           :field/default-visibility {:editor :editor.type/date}
                           :field/translations       {:en "Date"}}
   :test/datetime         {:field/default-ord        2
                           :field/data-type          :data.type/datetime
                           :field/default-visibility {:editor :editor.type/datetime}
                           :field/translations       {:en "Datetime"}}
   :test/email            {:field/default-ord        3
                           :field/data-type          :data.type/email
                           :field/default-visibility {:editor :editor.type/email}
                           :field/constraints        {:constraint/valid-email true}
                           :field/translations       {:en "Email"}}
   :test/integer          {:field/default-ord        4
                           :field/data-type          :data.type/integer
                           :field/constraints        {:constraint/greater-than-inclusive
                                                      -9007199254740991
                                                      :constraint/smaller-than-inclusive
                                                      9007199254740991}
                           :field/default-visibility {:editor :editor.type/integer}
                           :field/translations       {:en "Integer"}}
   :test/number           {:field/default-ord        5
                           :field/data-type          :data.type/number
                           :field/default-visibility {:editor :editor.type/number}
                           :field/constraints        {:constraint/greater-than 10
                                                      :constraint/smaller-than-inclusive 100}
                           :field/translations       {:en "Number"}}
   :test/url              {:field/default-ord        6
                           :field/data-type          :data.type/text-url
                           :field/default-visibility {:editor :editor.type/url}
                           :field/constraints        {:constraint/valid-url true}
                           :field/translations       {:en "URL"}}

   :test/percentage       {:field/default-ord        7
                           :field/data-type          :data.type/percentage
                           :field/default-visibility {:editor :editor.type/percentage}
                           :field/constraints        {:constraint/greater-than-inclusive 10.00
                                                      :constraint/smaller-than-inclusive 100.00}
                           :field/translations       {:en "Percenage [10.0% - 100.00%]"}}

   :test/multiplier       {:field/default-ord        7
                           :field/data-type          :data.type/multiplier
                           :field/default-visibility {:editor :editor.type/multiplier}
                           :field/constraints        {:constraint/greater-than-inclusive 0.01
                                                      :constraint/smaller-than-inclusive 100.00}
                           :field/translations       {:en "Multiplier 0.01x -> 100.00x"}}

   :test/textarea         {:field/default-ord        8
                           :field/data-type          :data.type/text-multiline
                           :field/default-visibility {:editor :editor.type/textarea}
                           :field/constraints        {:constraint/string-min-length 1
                                                      :constraint/string-max-length 100}
                           :field/translations       {:en "Textarea [1-100]"}}
   :test/toggle-no-labels {:field/default-ord        9.0
                           :field/data-type          :data.type/boolean
                           :field/default-visibility {:editor :editor.type/toggle}
                           :field/translations       {:en "Toggle no labels"}}
   :test/toggle-labels    {:field/default-ord        9.1
                           :field/data-type          :data.type/boolean
                           :field/default-visibility {:editor :editor.type/toggle}
                           :field/translations       {:en "Toggle"}
                           :toggle-on-text           "Yes"
                           :toggle-off-text          "No"}
   :test/toggle           {:field/default-ord        9.2
                           :field/data-type          :data.type/boolean
                           :field/default-visibility {:editor :editor.type/toggle}
                           :field/translations       {:en "Toggle long labels"}
                           :toggle-on-text           "Long On"
                           :toggle-off-text          "Longer toggle label - off"}
   :test/radio            {:field/default-ord  10
                           :field/data-type    :data.type/boolean
                           :field/default-visibility {:editor :editor.type/radio}
                           :field/translations {:en "Radio"}
                           :value-type         :keyword
                           :options            [{:key   :key-1
                                                 :label "Radio 1"}
                                                {:key   :key-2
                                                 :label "Radio 2"}
                                                {:key   :key-3
                                                 :label "Radio 3"}]}
   :test/multi-select     {:field/default-ord 11
                           :field/default-visibility {:editor :editor.type/multi-select}
                           :field/translations {:en "Multi-select"}
                           :value-type        :keyword
                           :options           [{:key   :option-1
                                                :label "Option 1"}
                                               {:key   :option-2
                                                :label "Option 2"}
                                               {:key   :option-3
                                                :label "Option 3"}
                                               {:key   :option-4
                                                :label "Option 4"}]}
   :test/multi-select-creatable {:field/default-ord  11
                                 :field/default-visibility {:editor :editor.type/multi-select}
                                 :create-on-fly?     true
                                 :force-has-access?  true
                                 :field/translations {:en "Multi-select"}
                                 :value-type         :keyword
                                 :options            [{:key   :option-1
                                                       :label "Option 1"}
                                                      {:key   :option-2
                                                       :label "Option 2"}
                                                      {:key   :option-3
                                                       :label "Option 3"}
                                                      {:key   :option-4
                                                       :label "Option 4"}]}
   :test/select           {:field/default-ord 12
                           :field/data-type :data.type/currency-symbol
                           :field/default-visibility {:editor :editor.type/select}
                           :options currencies/options
                           :value-type :keyword
                           :value :eur
                           :field/translations {:en "Select (single)"}}
   :test/wysiwyg          {:field/default-ord        13
                           :field/data-type          :data.type/text-richtext
                           :field/default-visibility {:editor :editor.type/wysiwyg}
                           :field/constraints        {:constraint/string-min-length 1
                                                      :constraint/string-max-length 100}
                           :field/translations       {:en "Wysisyg [1-100]"}}

   :test/read-only-select {:field/default-ord 14
                           :field/data-type   :data.type/currency-symbol
                           :field/default-visibility {:editor :editor.type/select}
                           :value             :eur
                           :read-only?        true
                           :options           currencies/options
                           :value-type        :keyword
                           :field/translations {:en "read-only Select"}}

   :test/parent-select    {:field/default-ord  15
                           :field/data-type    :data.type/currency-symbol
                           :field/default-visibility {:editor :editor.type/select}
                           :value-type         :keyword
                           :options            currencies/options
                           :field/translations {:en
                                                "Select - must be selected before next is enabled"}}

   :test/disabled-unless-related-selected
   {:field/default-ord  16
    :field/data-type    :data.type/currency-symbol
    :field/default-visibility {:editor :editor.type/select}
    :field/related-fields {:test/parent-select :required-value}
    :value-type         :keyword
    :options            currencies/options
    :field/translations {:en "Disabled if previous not selected"}}
  })

(def view-test-template
  (->> (select-keys test-schema
                    (if false
                      (keys test-schema)
                      [:test/multi-select-creatable
                       :test/select]))

       (map (fn [[attribute field-schema]]
              (merge field-schema
                     {:attribute   attribute
                      :editor/type (->> field-schema
                                        :field/default-visibility
                                        :editor)})))))

(def test-template-lookup
  (->> view-test-template
       (map (fn [field-schema]
              [(:attribute field-schema) field-schema]))
       (into {})))


(defn mandatory-field?
  [field]
  (some #{(:attribute field)} [:oppo/name]))

(defn draggable?
  [field]
  (not (some #{(:attribute field)} [:oppo/name])))

(defn editor-test-view
  [e-atom enriched-entity & [read-only?]]
  [:div
   [:ul
    [:li
     [:a
      {:href     "#"
       :on-click (fn [e]
                   (routing/set-view! [(if read-only?
                                         :test/field-editor
                                         :test/field-editor-read-only)])
                   (.preventDefault e))}
      (if read-only?
        "RW mode"
        "Read-only mode")]]]
   (doall
    (->>
     view-test-template
     (sort-by :field/default-ord)
     (map (fn [{:keys [:attribute] :as field-schema}]
            (let [value (or (get @e-atom attribute) (:value field-schema))
                  intelligence-value (get enriched-entity attribute)
                  is-intelligence-value? (and (nil? value) intelligence-value)]
              (when-not (:field/secondary-field? field-schema) ;; secondary fields are shown in related fields in editor
                ^{:key attribute}
                [field-editor/view
                 (merge
                  field-schema
                  {:state-atom   test-state                 ;; state is passed  from outside so debugging is easier
                   :value        (if is-intelligence-value? intelligence-value value)
                   :label        (or (->> field-schema
                                          :field/translations
                                          :en)
                                     (:field/name field-schema)
                                     (loc/tr attribute)
                                     (loc/field-name attribute field-schema)) ;; we select label outside of field-editor so we can customize label if needed
                   :mandatory?   mandatory-field?                             ;; can be function or boolean - most likely always view dependent
                   :info-text    (fn [fld]                                    ;; can pass text instead of function too
                                   ;; we can get info text from tenant settings here
                                   (when (= (:attribute fld) :test/text)
                                     "This field can be 1 - 10 characters"))
                   :read-only?   (or (:read-only? field-schema)
                                     read-only?)
                   :placeholder  (field/placeholder field-schema)
                   :drag-options {:draggable? draggable?}   ;; drag callbacks here too
                   ;; tools are configured by need - all handlers are inside as currently the tools have no side effects
                   :tools        [:tool-item/cancel :tool-item/save :tool-item/edit :tool-item/copy
                                  :tool-item/open-url #_:tool-item/clear]
                   :validate!    (fn [attribute value]
                                   (let [schema (get test-template-lookup attribute)
                                         field-constraints (:field/constraints schema)
                                         errors (constraints/validate field-constraints
                                                                      "test-id"
                                                                      value
                                                                      (constantly nil)
                                                                      []
                                                                      loc/tr
                                                                      logging/warn)]
                                     errors))
                   :error-text   nil
                   :on-save!     (fn [attribute new-value]
                                   (swap! e-atom assoc attribute new-value))}
                  (when is-intelligence-value?              ;; we decide source outside
                    {:source-options {:source-icon-fn intelligence-icon/view}})
                  (when (= :oppo/regions attribute)
                    {:options [{:label "Europe"
                                :key   :europe}
                               {:label "USA"
                                :key   :usa}]})
                  (when-let [secondary-attribute (:field/secondary-attribute field-schema)] ;; secondary attribute
                    {:secondary-view-args
                     (let [sec-templ (get test-template-lookup secondary-attribute)]
                       (merge
                        sec-templ
                        {:state-atom test-state
                         :label      (loc/tr secondary-attribute) ;; when we have custom dynamic fields the labels come from tenant configuration
                         :mandatory? mandatory-field?
                         :error-text nil
                        }))}))]))))))])

(defn cell-editor
  [row-id attribute entity enriched-entity]
  (let [value (get entity attribute)
        intelligence-value (get enriched-entity attribute)
        field-schema (get test-template-lookup attribute)
        editor-type (:editor/type field-schema)]
    [:span
     (if editor-type
       [editor
        (merge
         field-schema
         {:value         (or value intelligence-value)
          :tenant        @session/tenant
          :tenant-schema @session/tenant-schema
          :state-atom    (r/cursor test-table-temp-atom [(:db/id entity) attribute])
          :has-focus?    (= attribute (:focus-on @test-table-atom))
          :class-name    ""                           ;; TODO: error class here
          :on-focus!     (fn [e]
                           (swap! test-table-atom assoc :focus-on attribute))
          :on-blur!      (fn [e]
                           (let [new-value (-> e
                                               .-target
                                               .-value)]
                             (swap! test-table-atom dissoc :focus-on)
                             (swap! test-entities assoc-in [row-id attribute] new-value) ;; save in backend - only the successful return should reset the atom

                             #_(when true             ;; successful save
                                 (swap! test-table-atom dissoc-in [(:db/id entity) attribute]))
                           ))})]
       value)]))

(defn table-test-view
  [entities-state columns]
  (let [entities @entities-state]
    [:table.zap-table.zap-table--striped
     [:thead.zap-table__head
      [:tr.zap-table__row
       (doall (for [column columns]
                ^{:key column}
                [:th.zap-table__headline
                 (loc/tr column)]))]]
     [:tbody.zap-table__body
      (doall (->> entities
                  (map-indexed
                   (fn [index entity]
                     ^{:key (:oppo/name entity)}
                     [:tr.zap-table__row
                      (let [enriched-entity (ic/enrich-entity entity)]
                        (doall (for [column columns]
                                 ^{:key (str (:oppo/name enriched-entity) column)}
                                 [:td.zap-table__cell
                                  [cell-editor index column entity enriched-entity]])))]))))]]))

(defmethod routing/render-view :test/field-editor
  [{:keys [route-params]}]
  (let [_ (when (nil? @test-entity)
            (swap! db/app-state assoc-in
              [:test :test-data]
              {:test/text     "Test"
               :entity/type   :entity.type/test-data
               :test/checkbox true
               :test/toggle   true
               :test/radio    true
               :test/date     (.getTime (js/Date.))}))
        enriched-entity (ic/enrich-entity @test-entity)]
    [:div.zap-page.fields-test
     (editor-test-view test-entity enriched-entity)
    ]))

(defmethod routing/render-view :test/field-editor-read-only
  [{:keys [route-params]}]
  (let [_ (when (nil? @test-entity-read-only)
            (swap! db/app-state assoc-in
              [:test :test-data-read-only]
              {:test/email            "test.email@zapflow.com"
               :entity/type           :entity.type/test-data
               :test/toggle           true
               :test/toggle-labels    false
               :test/toggle-no-labels false
               :test/integer          75
               :test/read-only-select :usd
               :test/url              "https://www.zapflow.com"
               :test/text             "Zapflow Oy"
               :test/select           :eur
               :test/disabled-unless-related-selected nil
               :test/radio            :key-2
               :test/checkbox         true
               :test/wysiwyg          "<ul><li>an item 1</li><li>item 2</li></ul>"
               :test/percentage       20.2
               :test/parent-select    :eur
               :test/number           0.75
               :test/date             1544010199000
               :test/multi-select     #{:option-1 :option-2}
               :test/textarea         "Textarea text \n\nnew lines before"}))
        enriched-entity (ic/enrich-entity @test-entity-read-only)]
    [:div.zap-page.fields-test
     (editor-test-view test-entity-read-only enriched-entity true)
    ]))

(defmethod routing/render-view :test/table-inputs
  [{:keys [route-params]}]
  (let [_ (when (nil? @test-entities)
            (reset! test-entities
              [{:db/id 1
                :entity/type :entity.type/oppo
                :oppo/name "Deal1"
                :oppo/deal-description "Description1"
                :oppo/cur-round-size 100000
                :oppo/cur-round-size--sym :usd}
               {:db/id 2
                :entity/type :entity.type/oppo
                :oppo/name "Deal2"
                :oppo/deal-description "Description2"
                :oppo/cur-round-size 200000
                :oppo/cur-round-size--sym :eur}
               {:db/id 3
                :entity/type :entity.type/oppo
                :oppo/name "Deal3"
                :oppo/deal-description "Description3"
                :oppo/cur-round-size 300000
                :oppo/cur-round-size--sym :gbp}
               {:db/id 4
                :entity/type :entity.type/oppo
                :oppo/name "Deal4"
                :oppo/deal-description "Description4"
                :oppo/cur-round-size 400000
                :oppo/cur-round-size--sym :usd}]))]
    [:div.zap-page.fields-test
     (table-test-view test-entities
                      [:oppo/name :oppo/deal-description :oppo/cur-round-size
                       :oppo/cur-round-size--sym])
    ]))
